import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import MenuCatAl from "./pages/MenuCatAl";
import MenuCatIta from "./pages/MenuCatIta";
import MenuCatEn from "./pages/MenuCatEn";
import Footer from "./components/Footer";
import CatListItems from "./pages/CatListItems";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { useEffect, useState } from "react";
import NotFound from "./pages/NotFound";
import React from "react";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return clearTimeout(setIsLoading);
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader
          type="TailSpin"
          color="#fff"
          height={80}
          width={80}
          style={{
            position: "absolute",
            top: "calc(50% - 40px)",
            left: "calc(50% - 40px)",
          }}
        />
      ) : (
        <Router>
          <Navbar />
          <Switch>
            <Route path="/" exact component={LandingPage} />
            <Route path="/menu-shqip" component={MenuCatAl} />
            <Route path="/menu-italiano" component={MenuCatIta} />
            <Route path="/menu-english" component={MenuCatEn} />

            {/* Alb */}
            <Route path="/supa" component={CatListItems} />
            <Route path="/sallata" component={CatListItems} />
            <Route path="/antipasta" component={CatListItems} />
            <Route path="/pizza" component={CatListItems} />
            <Route path="/baguette" component={CatListItems} />
            <Route path="/calzone" component={CatListItems} />
            <Route path="/conchas" component={CatListItems} />
            <Route path="/pasta" component={CatListItems} />
            <Route path="/risoto" component={CatListItems} />
            <Route path="/quinoa" component={CatListItems} />
            <Route path="/pjata-kryesore" component={CatListItems} />
            <Route path="/embelsira" component={CatListItems} />
            <Route path="/pijet" component={CatListItems} />

            {/* Ita */}
            <Route path="/zuppe" component={CatListItems} />
            <Route path="/insalate" component={CatListItems} />
            <Route path="/antipaste" component={CatListItems} />
            <Route path="/pizza-ita" component={CatListItems} />
            <Route path="/baguette-ita" component={CatListItems} />
            <Route path="/calzone-ita" component={CatListItems} />
            <Route path="/conchas-ita" component={CatListItems} />
            <Route path="/paste" component={CatListItems} />
            <Route path="/rissoto" component={CatListItems} />
            <Route path="/quinoa-ita" component={CatListItems} />
            <Route path="/secondi-piatti" component={CatListItems} />
            <Route path="/dolci" component={CatListItems} />
            <Route path="/bevande" component={CatListItems} />

            {/* Eng */}
            <Route path="/soups" component={CatListItems} />
            <Route path="/salads" component={CatListItems} />
            <Route path="/appetizers" component={CatListItems} />
            <Route path="/pizza-eng" component={CatListItems} />
            <Route path="/baguette-eng" component={CatListItems} />
            <Route path="/calzone-eng" component={CatListItems} />
            <Route path="/conchas-eng" component={CatListItems} />
            <Route path="/pastas" component={CatListItems} />
            <Route path="/rissoto-eng" component={CatListItems} />
            <Route path="/quinoa-eng" component={CatListItems} />
            <Route path="/main-dishes" component={CatListItems} />
            <Route path="/desserts" component={CatListItems} />
            <Route path="/drinks" component={CatListItems} />

            {/* 404 Page */}
            <Route path="" component={NotFound} />
          </Switch>
          <Footer />
        </Router>
      )}
    </>
  );
}

export default App;
